import type { DrawingLine, NormalizedPoint, SupportedPointerType } from '../model';

export interface DraftLine {
  readonly pointerId: number;
  readonly pointerType: SupportedPointerType;
  readonly start: NormalizedPoint;
  readonly end: NormalizedPoint;
}

export function toSupportedPointerType(value: string): SupportedPointerType {
  if (value === 'mouse' || value === 'pen' || value === 'touch') {
    return value;
  }
  return 'unknown';
}

export function createCommittedLine(draft: DraftLine): DrawingLine {
  return {
    id: globalThis.crypto?.randomUUID?.() ?? `line-${Date.now()}-${draft.pointerId}`,
    pointerType: draft.pointerType,
    start: draft.start,
    end: draft.end,
    createdAt: new Date().toISOString()
  };
}
